/* eslint-disable security/detect-object-injection */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import  { Suspense,useContext,useEffect } from 'react';
import { useDispatch ,useSelector} from 'react-redux';
import React from 'react';
import { verifyOtp, logIn, setUserType } from '../pages/auth/authSlice'
import {CognitoCurrentData,CognitoData} from '../CommonMethods/CognitoData'
import {Route,Navigate,Routes,useNavigate,useLocation} from 'react-router-dom';
import GlobalContext from '../components/Context/GloablContext';
import AnimatedPage from '../components/Animation/AnimatedPage';
import LoginPage from '../pages/auth/LoginForm';
import { ComponentsBasedOnRole } from './_nav';
import { handleIsUserScreen, handleIsViewScreen, handleLocationKey, resetFilterState, resetState ,handleEditMessageSent,handleTargetUserEditId} from '../redux/systemConfigSlice';
import { resetArrays } from '../redux/MultiselectRows';
import Layout from '../components/Layout';
import SideBar from '../components/Layout/Sidebar';
import Noroute from '../components/Noroutes';
import SearchEmptyScreen from '../components/SearchEmptyScreen';
import ResetPassword from '../pages/auth/LoginForm/Components/ResetPassword';
import { resetOrgList } from '../pages/ManageOrganizations/usersSlice';
import { resetMonitorList } from '../pages/ManageOrganizations/monitorsSlice';
import ForgotResetPassword from '../pages/auth/LoginForm/Components/ForgotResetPassword';
import { resetSubDivList } from '../pages/ManageAdminAndCoporateUser/subdivisionSlice';
import { handleSidebarAnimation } from '../redux/commonSlice';
import { resetObserverList } from '../pages/ManageOrganizations/observersSlice';
import UpdatePassword from '../pages/Profile/UpdatePassword.jsx';
import EmailVerificationScreen from '../CommonMethods/EmailAddressVerification.jsx';
import { resetProviderList } from '../pages/ManageOrganizations/providersSlice.js';
import { syncSessionFromLocalStorage, getAuthItem, subscribeToAuthEvents } from '../CommonMethods/authSession';
import { usersList } from '../features/apiSlice';

export default function NavigationRoutes(props) {
    const dispactch=useDispatch()
    const auth=useSelector(state=>state?.auth)
    const viewId=useSelector(state=>state?.systemConfigData?.viewToHistory)
    const location = useLocation();
    const {UpdateCall,initialRoutePath,setInitialRoutePath,editSocket,setEditSocket}=useContext(GlobalContext)
    const restrict = useSelector((state)=>state?.systemConfigData?.restrict)
    const {loggedIn, userType} = auth
    const CurrentUser = userType || getAuthItem('user_type')
    const editingUserId = useSelector((state)=>state?.systemConfigData?.editingUserId)
    const messageSent = useSelector((state)=>state?.systemConfigData?.messageSent)
    const navigate = useNavigate()
    
    // Listen for login events from other tabs - re-initialize session when login happens in another tab
    useEffect(() => {
        const unsubscribe = subscribeToAuthEvents((eventType) => {
            if (eventType === 'login') {
                // User logged in from another tab - sync session and invalidate cache
                syncSessionFromLocalStorage();

                // Flip auth state in this tab so route guards re-render immediately.
                const storedUserType = getAuthItem('user_type');
                if (storedUserType) {
                    dispactch(setUserType(storedUserType));
                }
                dispactch(logIn(getAuthItem('email') || ''));

                dispactch(usersList.util.resetApiState());
                dispactch(usersList.util.invalidateTags(['User', 'History']));
            }
        });
        return unsubscribe;
    }, [dispactch]);
  
    // Handle loggedIn state changes - clear state when logged out
    useEffect(() => {
        if(!loggedIn){
            // User logged out - clear state
            dispactch(resetState())
        }
    }, [loggedIn, dispactch]);


    useEffect(()=>{
        
        const editRoutes = ['/manage-admin-corporate/add-admin-corporate/:id','/manage-organizations/add-organization/:id','/manage-provider/add-provider/:id','/manage-device-templates/edit-device-template/:id','/manage-devices/edit-device/:id','/manage-organizations/manage-organization-users/edit-organization-user/:id','/manage-monitoring-condition-templates/add-template/:id','/manage-observer/edit-observer/:id','/manage-patients/edit-patients/:id','/manage-monitor-user/add-monitor-user/:id']
        if(!editRoutes.includes(location.pathname)&&(editingUserId!==''||messageSent===true)){
            // dispactch(handleTargetUserEditId(''))
            // dispactch(handleEditMessageSent(false))
        }
        if(!location.pathname.includes('activity_history')){
            dispactch(handleIsViewScreen(['']))
        }
        if(!location.search.includes('filter')){
            dispactch(resetFilterState())
        }
        if(!location.pathname.includes('manage-organizations')){
            dispactch(handleIsUserScreen(['','']))
        }
        dispactch(resetArrays())
        if((!location.pathname.includes('add-organization'))&&(!location.pathname.includes('edit-patients'))){
            dispactch(resetOrgList())
            dispactch(resetMonitorList())
            dispactch(resetProviderList())
            dispactch(resetObserverList())
        }
        if(!location.pathname.includes('add-admin-corporate')){
            dispactch(resetSubDivList())
        }
        // if((sessionStorage.getItem("key")===location.pathname)){
        //     dispactch(handleSidebarAnimation(true))
        // }
        // else{
        //     dispactch(handleSidebarAnimation(false))
        // }
            
        sessionStorage.setItem('key',location.pathname)
    },[dispactch,location.pathname])


   

    return (
        <Suspense fallback={<div></div>}>
            <Routes location={location} key={location.pathname}>
                <Route path="/email-address-verification" element={
                    <AnimatedPage>
                        <EmailVerificationScreen />
                    </AnimatedPage>
                }/>
                {(!loggedIn||(getAuthItem('custom:is_first_time_login')==="true"))?<>
                    <Route path="/" element={
                        <AnimatedPage><LoginPage /></AnimatedPage>} />
                    <Route path="/reset-password" element={
                        getAuthItem('custom:is_first_time_login') === "true" ? (
                            <AnimatedPage>
                                <ResetPassword />
                            </AnimatedPage>
                        ) : (
                            <Navigate to="/" replace />
                        )} />
                    <Route path="/reset-new-password/" element={
                        <AnimatedPage><ForgotResetPassword /></AnimatedPage>} />
                    <Route path="/404" element={
                        <>
                            <SearchEmptyScreen text={"404: Page Not Found. We’re sorry, but the page you’re looking for doesn’t exist. Please check the URL and try again later."} />
                        </>} />  
                    {/* <Route
                        path="*"
                        element={
                            <Noroute/>
                        }
                    /> */}
                    <Route
                        path="*"
                        element={
                            <Navigate replace to='/'/>} 
                            
                    />
                </>:(
                    ComponentsBasedOnRole[CurrentUser]&&
                    <Route path={'/'} element={<Layout/>}>
                        {restrict?(<><Route path={'/'} element={React.cloneElement(ComponentsBasedOnRole[CurrentUser][0].element, props)}  key={'/profile'}/><Route path={'/profile/update-password'} element={<UpdatePassword/>}  key={'/profile/update-password'}/></>):ComponentsBasedOnRole[CurrentUser]?.map((nav)=>(
                            ((CurrentUser === "super-admin"||CurrentUser === "admin-user" || CurrentUser==='corporate-user')) &&
                            !(nav.path === '/system-configuration' && CurrentUser === 'corporate-user') &&
                            <Route path={nav.path} element={React.cloneElement(nav.element, props)}  key={nav.path}/>
                        ))}
                        {restrict? <Route path="*" element={<Navigate to="/" />} />:<Route
                            path="*"
                            element={
                                <>
                                    <SearchEmptyScreen text={"404"} />
                                </>} 
                            
                        />}
                        {CurrentUser === 'corporate-user' && <Route path="/system-configuration" element={<Navigate to="/profile" />} />}
                        <Route path="/404" element={
                            <SearchEmptyScreen text={"404: Page Not Found. We’re sorry, but the page you’re looking for doesn’t exist. Please check the URL and try again later."} />
                        } />  
                    </Route>
                    
                )
                }
            
                <Route
                    path="*"
                    element={
                        <Noroute/>} 
                            
                />
                
            </Routes>
        </Suspense>
    );
}